import React from "react";

const MsLogo = ({}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="40"
      height="40"
      viewBox="0 0 256 256"
      style={{ mixBlendMode: "normal" }}
    >
      <g fill="none" fillRule="nonzero">
        <g transform="scale(5.33333,5.33333)">
          <path
            d="M21,31c0,1.104 0.896,2 2,2h17c1.104,0 2,-0.896 2,-2v-15c0,-1.104 -0.896,-2 -2,-2h-17c-1.104,0 -2,0.896 -2,2z"
            fill="#0684d1"
          />
          <path
            d="M42,16.975v-0.975c0,-0.428 -0.137,-0.823 -0.367,-1.148l-11.264,6.932l-7.542,-4.656l-0.702,1.872l8.459,5z"
            fill="#ffffff"
          />
          <path d="M27,41.46l-21,-4v-28l21,-4z" fill="#0277bd" />
          <path
            d="M21.216,18.311c-1.098,-1.275 -2.546,-1.913 -4.328,-1.913c-1.892,0 -3.408,0.669 -4.554,2.003c-1.144,1.337 -1.719,3.088 -1.719,5.246c0,2.045 0.564,3.714 1.69,4.986c1.126,1.273 2.592,1.91 4.378,1.91c1.84,0 3.331,-0.652 4.474,-1.975c1.143,-1.313 1.712,-3.043 1.712,-5.199c0,-2.088 -0.551,-3.774 -1.653,-5.058zM19.049,26.735c-0.568,0.769 -1.339,1.152 -2.313,1.152c-0.939,0 -1.699,-0.394 -2.285,-1.187c-0.581,-0.785 -0.87,-1.861 -0.87,-3.211c0,-1.336 0.289,-2.414 0.87,-3.225c0.586,-0.81 1.368,-1.211 2.355,-1.211c0.962,0 1.718,0.393 2.267,1.178c0.555,0.795 0.833,1.895 0.833,3.31c0.001,1.365 -0.288,2.427 -0.857,3.194z"
            fill="#ffffff"
          />
        </g>
      </g>
    </svg>
  );
};

const StaticInfoIcon = ({ color, size }) => {
  return (
    <svg
      fill={color}
      version="1.1"
      id="Capa_1"
      viewBox="0 0 60 60"
      stroke="#ffffff"
      strokeWidth="1"
      height={size}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <g>
            {" "}
            <path d="M2,7H0v52c0,0.6,0.4,1,1,1h34v-2H2V7z"></path>{" "}
            <path d="M6,2h31v8c0,0.6,0.4,1,1,1h8v3h2v-4l0,0c0-0.1,0-0.2-0.1-0.3V9.6c-0.1-0.1-0.1-0.2-0.2-0.3l-9-9c-0.1-0.1-0.2-0.1-0.3-0.2 h-0.1C38.2,0.1,38.1,0,38,0l0,0H5C4.4,0,4,0.4,4,1v54c0,0.6,0.4,1,1,1h34v-2H6V2z M44.6,9H39V3.4L44.6,9z"></path>{" "}
            <rect x="23" y="27" width="2" height="2"></rect>{" "}
            <rect x="19" y="27" width="2" height="2"></rect>{" "}
            <rect x="15" y="27" width="2" height="2"></rect>{" "}
            <rect x="11" y="27" width="2" height="2"></rect>{" "}
            <rect x="27" y="27" width="2" height="2"></rect>{" "}
            <rect x="9" y="5" width="2" height="2"></rect>{" "}
            <rect x="13" y="5" width="2" height="2"></rect>{" "}
            <rect x="13" y="9" width="2" height="2"></rect>{" "}
            <rect x="9" y="9" width="2" height="2"></rect>{" "}
            <rect x="17" y="5" width="8" height="2"></rect>{" "}
            <rect x="17" y="9" width="8" height="2"></rect>{" "}
            <rect x="9" y="16" width="26" height="2"></rect>{" "}
            <rect x="9" y="21" width="34" height="2"></rect>{" "}
            <rect x="9" y="33" width="34" height="2"></rect>{" "}
            <rect x="9" y="38" width="34" height="2"></rect>{" "}
            <rect x="9" y="43" width="22" height="2"></rect>{" "}
            <rect x="33" y="43" width="2" height="2"></rect>{" "}
            <rect x="37" y="43" width="2" height="2"></rect>{" "}
            <rect x="41" y="43" width="2" height="2"></rect>{" "}
            <path d="M56,33c-1.9,0-3.4,1.3-3.9,3H48v-7h6c0.6,0,1-0.4,1-1V11.9c1.7-0.4,3-2,3-3.9c0-2.2-1.8-4-4-4s-4,1.8-4,4 c0,1.9,1.3,3.4,3,3.9V27H31v2h15v19.1c-1.7,0.4-3,2-3,3.9c0,2.2,1.8,4,4,4s4-1.8,4-4c0-1.9-1.3-3.4-3-3.9V38h4.1 c0.4,1.7,2,3,3.9,3c2.2,0,4-1.8,4-4S58.2,33,56,33z M52,8c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S52,9.1,52,8z M49,52 c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S49,50.9,49,52z M56,39c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S57.1,39,56,39z"></path>{" "}
            <rect x="9" y="48" width="12" height="2"></rect>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};

const DashboardIcon = ({ color, size }) => {
  return (
    <svg
      className="sidebar-svg-icons"
      fill={color}
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 22.2 22.2"
      height={size}
    >
      <path d="M18.20,0H4.00C1.79,0,0,1.79,0,4.00V18.20C0,20.41,1.79,22.20,4.00,22.20H18.20C20.41,22.20,22.20,20.41,22.20,18.20V4.00C22.20,1.79,20.41,0,18.20,0zM20.20,4.00V13.80H12.10V2.00H18.20C19.30,2.00,20.20,2.90,20.20,4.00zM4.00,2.00H10.10V6.40H2.00V4.00C2.00,2.90,2.90,2.00,4.00,2.00zM2.00,18.20V8.40H10.10V20.20H4.00C2.90,20.20,2.00,19.30,2.00,18.20zM18.20,20.20H12.10V15.80H20.20V18.20C20.20,19.30,19.30,20.20,18.20,20.20z"></path>
    </svg>
  );
};

const ArticleIcon = ({ color, size }) => {
  return (
    <svg
      className="sidebar-svg-icons"
      fill={color}
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 57.34 62.75"
      height={size}
    >
      <path d="M54.57,62.75H9.43C4.22,62.75,0,58.53,0,53.32V14.84C0,14.72,0.01,14.59,0.02,14.46C0.03,14.39,0.03,14.32,0.04,14.25C0.04,14.24,0.04,14.23,0.04,14.22L0.05,14.18V14.18C0.13,13.65,0.29,13.15,0.54,12.69C0.59,12.60,0.64,12.52,0.69,12.44C0.73,12.37,0.78,12.31,0.83,12.24L0.85,12.22C0.88,12.18,0.90,12.15,0.92,12.12C1.11,11.87,1.33,11.64,1.56,11.45C1.82,11.20,3.28,9.76,10.73,2.30L10.93,2.10C11.53,1.34,12.37,0.80,13.31,0.56C13.35,0.55,13.39,0.54,13.43,0.53C13.44,0.53,13.44,0.53,13.45,0.53C13.52,0.52,13.58,0.50,13.65,0.49C13.73,0.48,13.81,0.47,13.90,0.45C13.94,0.44,13.99,0.44,14.04,0.44C14.17,0.43,14.30,0.42,14.43,0.42H47.92C50.37,0.42,52.36,2.41,52.36,4.86V54.20C52.36,54.52,52.37,54.84,52.39,55.16V55.16C52.45,56.16,53.19,56.97,54.19,57.14C54.27,57.15,54.34,57.17,54.42,57.19C54.45,57.20,54.49,57.21,54.55,57.21C55.83,57.24,56.98,58.07,57.27,59.32C57.69,61.13,56.32,62.75,54.57,62.75zM5.55,15.30V53.32C5.55,55.46,7.29,57.20,9.43,57.20H47.13C47.01,56.79,46.93,56.37,46.87,55.93C46.82,55.72,46.79,55.50,46.79,55.28V5.97H14.89L14.64,6.22C8.31,12.57,6.27,14.60,5.55,15.30zM5.13,15.69C5.13,15.69,5.13,15.69,5.13,15.69C5.13,15.69,5.13,15.69,5.13,15.69zM1.62,11.39C1.61,11.40,1.60,11.41,1.59,11.42C1.60,11.40,1.61,11.39,1.62,11.39zM29.96,25.69H40.27C41.48,25.69,42.11,24.76,42.11,23.83S41.48,21.97,40.27,21.97H29.96C28.75,21.97,28.12,22.90,28.12,23.83S28.75,25.69,29.96,25.69zM29.96,32.40H40.27C41.48,32.40,42.11,31.47,42.11,30.54S41.48,28.68,40.27,28.68H29.96C28.75,28.68,28.12,29.61,28.12,30.54S28.75,32.40,29.96,32.40zM29.96,18.98H40.27C41.48,18.98,42.11,18.05,42.11,17.12S41.48,15.26,40.27,15.26H29.96C28.75,15.26,28.12,16.19,28.12,17.12S28.75,18.98,29.96,18.98zM11.96,32.40H23.96C24.98,32.40,25.82,31.57,25.82,30.54V17.12C25.82,16.10,24.99,15.26,23.96,15.26H11.96C10.94,15.26,10.10,16.09,10.10,17.12V30.55C10.11,31.57,10.94,32.40,11.96,32.40zM40.25,42.49H11.95C11.32,42.49,10.79,42.75,10.46,43.22C10.39,43.31,10.34,43.41,10.29,43.52C10.20,43.73,10.14,43.95,10.12,44.18C10.11,44.29,10.11,44.41,10.12,44.52C10.14,44.75,10.20,44.97,10.29,45.18C10.34,45.29,10.40,45.39,10.46,45.48C10.80,45.95,11.32,46.21,11.95,46.21H40.25C40.97,46.21,41.56,45.86,41.87,45.27C42.03,44.99,42.11,44.67,42.11,44.35C42.11,44.03,42.03,43.71,41.88,43.44C41.56,42.84,40.97,42.49,40.25,42.49zM40.25,35.78H11.95C10.74,35.78,10.11,36.71,10.11,37.64S10.74,39.50,11.95,39.50H40.25C41.29,39.50,42.11,38.68,42.11,37.64C42.10,36.59,41.29,35.78,40.25,35.78zM40.25,49.20H11.95C10.74,49.20,10.11,50.13,10.11,51.06C10.11,51.98,10.74,52.92,11.95,52.92H40.25C41.29,52.92,42.11,52.10,42.11,51.06S41.29,49.20,40.25,49.20z"></path>
    </svg>
  );
};

const PlayIcon = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 576 512"
      height={size}
      className="sidebar-svg-icons"
      fill={color}
    >
      <path d="M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm331.7-18l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM192 335.8V176.9c0-4.7 5.1-7.6 9.1-5.1l134.5 81.7c3.9 2.4 3.8 8.1-.1 10.3L201 341c-4 2.3-9-.6-9-5.2z"></path>
    </svg>
  );
};

const VideoSection = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 576 512"
      className="sidebar-svg-icons"
      fill={color}
      height="1em"
    >
      <path d="M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm331.7-18l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM192 335.8V176.9c0-4.7 5.1-7.6 9.1-5.1l134.5 81.7c3.9 2.4 3.8 8.1-.1 10.3L201 341c-4 2.3-9-.6-9-5.2z"></path>
    </svg>
  );
};

const StartTimeIcon = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 32 32"
      className="sidebar-svg-icons pe-1"
      fill={color}
      height={size}
    >
      <path d="M 7 4 L 7 6 L 9 6 L 9 10 C 9 12.542969 10.367188 14.773438 12.40625 16 C 10.367188 17.226563 9 19.457031 9 22 L 9 26 L 7 26 L 7 28 L 25 28 L 25 26 L 23 26 L 23 22 C 23 19.457031 21.632813 17.226563 19.59375 16 C 21.632813 14.773438 23 12.542969 23 10 L 23 6 L 25 6 L 25 4 Z M 11 6 L 21 6 L 21 10 C 21 12.773438 18.773438 15 16 15 C 13.226563 15 11 12.773438 11 10 Z M 12 8 L 12 10 C 12 12.210938 13.789063 14 16 14 C 18.210938 14 20 12.210938 20 10 L 20 8 Z M 16 17 C 18.773438 17 21 19.226563 21 22 L 21 26 L 11 26 L 11 22 C 11 19.226563 13.226563 17 16 17 Z" />
    </svg>
  );
};

const EndTimeIcon = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 32 32"
      className="sidebar-svg-icons pe-1"
      fill={color}
      height={size}
    >
      <path d="M 7 4 L 7 6 L 9 6 L 9 10 C 9 12.542969 10.367188 14.773438 12.40625 16 C 10.367188 17.226563 9 19.457031 9 22 L 9 26 L 7 26 L 7 28 L 25 28 L 25 26 L 23 26 L 23 22 C 23 19.457031 21.632813 17.226563 19.59375 16 C 21.632813 14.773438 23 12.542969 23 10 L 23 6 L 25 6 L 25 4 Z M 11 6 L 21 6 L 21 10 C 21 12.773438 18.773438 15 16 15 C 13.226563 15 11 12.773438 11 10 Z M 16 17 C 18.773438 17 21 19.226563 21 22 L 21 26 L 20 26 L 20 24 C 20 21.789063 18.210938 20 16 20 C 13.789063 20 12 21.789063 12 24 L 12 26 L 11 26 L 11 22 C 11 19.226563 13.226563 17 16 17 Z" />
    </svg>
  );
};

const IdIcon = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 64 64"
      className="sidebar-svg-icons pe-1"
      fill={color}
      height={size}
    >
      <path
        d="M39 19.434h-5.384v25.133H39c2.969 0 5.386-2.322 5.386-5.174V24.609c0-2.853-2.417-5.175-5.386-5.175"
        fill="#000000"
      ></path>
      <path
        d="M52 2H12C6.477 2 2 6.477 2 12v40c0 5.523 4.477 10 10 10h40c5.523 0 10-4.477 10-10V12c0-5.523-4.477-10-10-10M23 49h-4V15h4v34m26-9.607a9.251 9.251 0 0 1-.787 3.738a9.592 9.592 0 0 1-2.143 3.055a10.032 10.032 0 0 1-3.178 2.059A10.302 10.302 0 0 1 39 49H29V15h10c1.348 0 2.657.254 3.893.754c1.19.484 2.26 1.176 3.178 2.059s1.638 1.912 2.143 3.053A9.294 9.294 0 0 1 49 24.609v14.784"
        fill="#000000"
      ></path>
    </svg>
  );
};

const ParticipantIcon = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 372.483 372.483"
      // xml:space="preserve"
      className="sidebar-svg-icons  pe-1"
      fill={color}
      height={size}
    //   height="1em"
    >
      <g id="XMLID_10_">
        <g>
          <path
            d="M372.482,263.045c0-21.796-6.527-42.842-18.877-60.863c-8.883-12.962-20.322-23.726-33.578-31.725
			c15.607-14.78,25.372-35.67,25.372-58.811c0-44.684-36.354-81.038-81.037-81.038c-26.496,0-51.316,13.104-66.392,34.615
			c-3.831-0.558-7.745-0.859-11.729-0.859s-7.897,0.302-11.728,0.859c-15.077-21.511-39.897-34.615-66.392-34.615
			c-44.684,0-81.038,36.354-81.038,81.038c0,23.141,9.765,44.031,25.373,58.811c-13.257,7.998-24.696,18.763-33.578,31.724
			C6.528,220.203,0,241.249,0,263.045v45.075h78.121v33.755h216.242V308.12h78.12v-45.075H372.482z M264.362,50.609
			c33.656,0,61.037,27.381,61.037,61.038s-27.381,61.038-61.037,61.038c-0.603,0-1.206-0.009-1.81-0.027
			c0.046-0.128,0.084-0.259,0.129-0.387c1.042-2.954,1.911-5.988,2.608-9.087c0.049-0.22,0.105-0.438,0.152-0.659
			c0.181-0.836,0.34-1.68,0.495-2.526c0.073-0.4,0.148-0.799,0.215-1.2c0.126-0.755,0.24-1.513,0.345-2.274
			c0.073-0.529,0.139-1.058,0.202-1.588c0.079-0.672,0.156-1.345,0.219-2.022c0.064-0.691,0.112-1.383,0.158-2.076
			c0.036-0.546,0.081-1.09,0.106-1.639c0.055-1.177,0.086-2.356,0.09-3.536c0-0.087,0.007-0.172,0.007-0.26
			c0-0.047-0.004-0.094-0.004-0.141c-0.002-1.205-0.037-2.403-0.091-3.597c-0.016-0.347-0.037-0.693-0.057-1.039
			c-0.059-1.015-0.136-2.025-0.231-3.03c-0.022-0.228-0.04-0.456-0.063-0.683c-3.022-29.209-21.475-54.21-48.095-65.774
			C230.208,58.253,246.8,50.609,264.362,50.609z M165.122,88.131c0.195-0.071,0.392-0.138,0.587-0.208
			c0.607-0.217,1.219-0.423,1.834-0.622c0.466-0.149,0.935-0.293,1.407-0.431c0.343-0.101,0.687-0.198,1.032-0.294
			c0.616-0.169,1.235-0.334,1.86-0.485c4.62-1.122,9.438-1.731,14.397-1.731c4.963,0.004,9.783,0.614,14.404,1.736
			c0.621,0.15,1.236,0.314,1.849,0.482c0.35,0.097,0.7,0.195,1.047,0.298c0.466,0.137,0.93,0.279,1.391,0.426
			c0.623,0.201,1.242,0.409,1.856,0.629c0.189,0.067,0.378,0.131,0.566,0.2c20.413,7.549,35.718,25.716,39.182,47.763
			c0.027,0.176,0.053,0.353,0.079,0.53c0.111,0.747,0.204,1.5,0.287,2.255c0.03,0.278,0.062,0.555,0.089,0.834
			c0.066,0.689,0.115,1.383,0.159,2.079c0.018,0.298,0.043,0.595,0.057,0.894c0.042,0.889,0.065,1.783,0.068,2.682
			c0,0.078,0.005,0.154,0.005,0.232c0,0.036-0.002,0.073-0.002,0.109c-0.002,0.87-0.028,1.734-0.066,2.595
			c-0.012,0.271-0.024,0.542-0.04,0.812c-0.047,0.832-0.109,1.66-0.189,2.482c-0.031,0.318-0.073,0.635-0.109,0.952
			c-0.061,0.532-0.129,1.063-0.203,1.591c-0.058,0.411-0.116,0.823-0.182,1.232c-0.101,0.623-0.213,1.242-0.333,1.859
			c-0.107,0.549-0.224,1.096-0.346,1.642c-0.073,0.329-0.149,0.658-0.228,0.985c-0.195,0.811-0.409,1.617-0.637,2.42
			c-0.091,0.319-0.176,0.64-0.272,0.956c-0.139,0.46-0.289,0.916-0.438,1.372c-0.12,0.365-0.243,0.728-0.37,1.09
			c-0.144,0.411-0.286,0.823-0.438,1.231c-0.259,0.693-0.531,1.38-0.814,2.061c-0.126,0.304-0.26,0.605-0.391,0.908
			c-0.247,0.567-0.501,1.131-0.765,1.689c-0.031,0.066-0.062,0.132-0.093,0.198c-0.095,0.198-0.189,0.397-0.286,0.595
			c-0.296,0.604-0.604,1.201-0.92,1.793c-0.123,0.23-0.242,0.463-0.368,0.692c-0.008,0.015-0.016,0.029-0.024,0.043
			c-0.346,0.63-0.707,1.25-1.074,1.866c-0.146,0.244-0.29,0.489-0.439,0.73c-0.4,0.649-0.811,1.291-1.234,1.923
			c-0.263,0.393-0.538,0.778-0.81,1.165c-0.231,0.328-0.461,0.657-0.698,0.98c-0.307,0.418-0.62,0.831-0.938,1.242
			c-0.216,0.279-0.434,0.556-0.654,0.832c-0.336,0.42-0.675,0.838-1.021,1.249c-0.215,0.255-0.436,0.505-0.655,0.756
			c-0.36,0.413-0.719,0.827-1.089,1.23c-0.22,0.239-0.448,0.469-0.672,0.705c-0.602,0.635-1.218,1.256-1.846,1.865
			c-0.373,0.361-0.744,0.723-1.126,1.074c-0.264,0.243-0.535,0.479-0.804,0.718c-0.438,0.389-0.879,0.774-1.328,1.15
			c-0.228,0.191-0.458,0.38-0.689,0.568c-0.543,0.442-1.093,0.875-1.652,1.299c-0.152,0.115-0.302,0.232-0.455,0.346
			c-10.16,7.553-22.736,12.03-36.34,12.03c-13.605,0-26.183-4.478-36.343-12.033c-0.15-0.112-0.297-0.227-0.446-0.34
			c-0.561-0.425-1.114-0.861-1.659-1.305c-0.229-0.187-0.458-0.374-0.684-0.564c-0.451-0.378-0.893-0.765-1.333-1.155
			c-0.267-0.238-0.537-0.472-0.8-0.714c-0.383-0.352-0.755-0.715-1.129-1.076c-0.631-0.611-1.248-1.234-1.852-1.871
			c-0.221-0.233-0.447-0.46-0.664-0.696c-0.371-0.404-0.73-0.819-1.09-1.232c-0.219-0.251-0.439-0.5-0.654-0.755
			c-0.347-0.411-0.685-0.829-1.021-1.248c-0.22-0.276-0.439-0.553-0.655-0.833c-0.317-0.41-0.63-0.823-0.937-1.241
			c-0.237-0.324-0.468-0.654-0.699-0.983c-0.272-0.386-0.546-0.77-0.808-1.162c-0.425-0.635-0.838-1.279-1.239-1.93
			c-0.147-0.239-0.289-0.48-0.433-0.721c-0.373-0.625-0.738-1.253-1.089-1.892c-0.129-0.235-0.251-0.474-0.378-0.71
			c-0.316-0.594-0.625-1.193-0.922-1.798c-0.106-0.215-0.209-0.432-0.312-0.648c-0.016-0.033-0.031-0.066-0.046-0.099
			c-0.277-0.584-0.542-1.174-0.801-1.769c-0.123-0.283-0.248-0.565-0.366-0.849c-0.29-0.696-0.567-1.398-0.832-2.106
			c-0.143-0.382-0.275-0.768-0.41-1.153c-0.139-0.395-0.273-0.793-0.404-1.192c-0.141-0.432-0.283-0.864-0.415-1.298
			c-0.197-0.649-0.383-1.302-0.558-1.959c-0.123-0.461-0.234-0.926-0.347-1.39c-0.088-0.365-0.173-0.73-0.254-1.097
			c-0.1-0.45-0.201-0.899-0.291-1.351c-0.139-0.704-0.266-1.412-0.38-2.124c-0.062-0.384-0.116-0.769-0.171-1.153
			c-0.081-0.569-0.154-1.141-0.219-1.715c-0.032-0.283-0.069-0.566-0.098-0.849c-0.083-0.843-0.146-1.692-0.194-2.544
			c-0.014-0.245-0.025-0.49-0.036-0.735c-0.041-0.911-0.07-1.825-0.07-2.745c0-0.986,0.028-1.965,0.075-2.94
			c0.013-0.265,0.035-0.528,0.05-0.792c0.044-0.732,0.097-1.462,0.167-2.188c0.024-0.253,0.053-0.505,0.08-0.757
			c0.086-0.786,0.183-1.568,0.299-2.345c0.022-0.151,0.044-0.303,0.068-0.454C129.393,113.864,144.701,95.685,165.122,88.131z
			 M47.083,111.647c0-33.656,27.381-61.038,61.038-61.038c17.563,0,34.154,7.645,45.625,20.529
			c-26.629,11.568-45.086,36.581-48.099,65.802c-0.021,0.198-0.036,0.397-0.055,0.596c-0.1,1.041-0.179,2.086-0.239,3.137
			c-0.018,0.32-0.038,0.639-0.053,0.96c-0.057,1.251-0.096,2.506-0.096,3.77c0,1.276,0.037,2.549,0.097,3.821
			c0.024,0.512,0.066,1.019,0.099,1.528c0.049,0.732,0.099,1.464,0.167,2.194c0.06,0.649,0.134,1.294,0.21,1.939
			c0.066,0.562,0.136,1.122,0.214,1.682c0.102,0.735,0.212,1.467,0.333,2.196c0.073,0.433,0.153,0.865,0.232,1.297
			c0.15,0.816,0.303,1.63,0.477,2.437c0.058,0.266,0.124,0.53,0.184,0.795c0.679,3.003,1.522,5.943,2.526,8.81
			c0.064,0.185,0.12,0.372,0.185,0.556c-0.603,0.018-1.207,0.027-1.809,0.027C74.464,172.684,47.083,145.303,47.083,111.647z
			 M94.888,239.148c-0.22,0.347-0.43,0.7-0.646,1.049c-0.457,0.738-0.91,1.478-1.348,2.225c-0.245,0.417-0.481,0.837-0.719,1.257
			c-0.394,0.693-0.783,1.388-1.161,2.089c-0.238,0.441-0.472,0.884-0.704,1.327c-0.364,0.697-0.719,1.398-1.067,2.101
			c-0.219,0.442-0.437,0.883-0.649,1.327c-0.354,0.741-0.695,1.488-1.032,2.236c-0.183,0.407-0.371,0.811-0.548,1.22
			c-0.39,0.896-0.762,1.799-1.127,2.705c-0.107,0.265-0.221,0.527-0.325,0.792c-0.463,1.177-0.906,2.362-1.326,3.553
			c-0.096,0.273-0.182,0.549-0.277,0.822c-0.316,0.918-0.624,1.839-0.915,2.764c-0.133,0.425-0.256,0.852-0.384,1.278
			c-0.235,0.784-0.466,1.569-0.683,2.359c-0.129,0.47-0.252,0.941-0.375,1.413c-0.198,0.758-0.388,1.518-0.568,2.281
			c-0.115,0.483-0.227,0.966-0.334,1.45c-0.172,0.773-0.333,1.549-0.488,2.326c-0.093,0.467-0.189,0.934-0.276,1.403
			c-0.157,0.846-0.298,1.696-0.435,2.547c-0.064,0.4-0.135,0.798-0.195,1.198c-0.186,1.25-0.355,2.503-0.497,3.762
			c-0.002,0.015-0.003,0.03-0.004,0.045c-0.129,1.145-0.24,2.292-0.333,3.443H20v-25.075c0-34.258,19.694-65.013,50.548-79.631
			c11.24,5.908,24.017,9.271,37.572,9.271c3.92,0,7.852-0.29,11.754-0.864c0.608,0.867,1.226,1.725,1.866,2.567
			c0.216,0.283,0.44,0.559,0.66,0.839c0.632,0.808,1.273,1.607,1.935,2.39c0.271,0.321,0.549,0.635,0.825,0.952
			c0.62,0.712,1.25,1.415,1.894,2.104c0.338,0.363,0.682,0.72,1.026,1.077c0.589,0.607,1.186,1.205,1.793,1.794
			c0.228,0.221,0.443,0.455,0.673,0.674c-0.869,0.525-1.73,1.063-2.583,1.612c-0.139,0.089-0.275,0.183-0.413,0.273
			c-0.853,0.554-1.697,1.12-2.533,1.697c-0.289,0.2-0.577,0.402-0.865,0.604c-0.745,0.525-1.482,1.059-2.213,1.602
			c-0.231,0.172-0.465,0.34-0.694,0.514c-0.93,0.703-1.849,1.419-2.756,2.151c-0.198,0.16-0.392,0.325-0.59,0.487
			c-0.722,0.591-1.437,1.192-2.143,1.802c-0.274,0.236-0.546,0.474-0.818,0.713c-0.707,0.623-1.405,1.255-2.096,1.896
			c-0.18,0.167-0.364,0.331-0.543,0.5c-0.848,0.798-1.683,1.611-2.506,2.438c-0.214,0.215-0.423,0.434-0.635,0.65
			c-0.63,0.643-1.253,1.293-1.868,1.952c-0.244,0.262-0.488,0.524-0.73,0.789c-0.692,0.756-1.374,1.522-2.045,2.299
			c-0.105,0.122-0.214,0.24-0.319,0.363c-0.765,0.893-1.513,1.803-2.251,2.722c-0.206,0.256-0.407,0.516-0.61,0.775
			c-0.555,0.705-1.102,1.417-1.64,2.136c-0.208,0.278-0.417,0.554-0.622,0.834c-0.704,0.96-1.399,1.928-2.074,2.913
			C96.274,236.998,95.572,238.069,94.888,239.148z M98.121,321.876v-13.755v-11.32c0-1.11,0.021-2.216,0.062-3.319
			c0.013-0.363,0.042-0.723,0.06-1.085c0.036-0.736,0.07-1.473,0.124-2.206c0.033-0.445,0.083-0.886,0.123-1.33
			c0.058-0.646,0.11-1.293,0.182-1.935c0.053-0.47,0.122-0.937,0.182-1.406c0.078-0.611,0.151-1.223,0.241-1.831
			c0.073-0.484,0.161-0.964,0.241-1.446c0.098-0.586,0.189-1.174,0.299-1.757c0.093-0.493,0.201-0.981,0.302-1.472
			c0.116-0.566,0.227-1.134,0.354-1.696c0.112-0.496,0.24-0.987,0.36-1.481c0.135-0.55,0.264-1.103,0.409-1.65
			c0.132-0.497,0.278-0.989,0.418-1.482c0.152-0.537,0.3-1.075,0.462-1.608c0.151-0.496,0.317-0.988,0.476-1.481
			c0.17-0.523,0.335-1.047,0.514-1.566c0.17-0.491,0.353-0.978,0.531-1.465c0.188-0.514,0.372-1.03,0.569-1.54
			c0.188-0.485,0.388-0.964,0.583-1.446c0.205-0.503,0.407-1.009,0.621-1.508c0.207-0.481,0.425-0.957,0.64-1.433
			c0.221-0.491,0.44-0.984,0.67-1.47c0.225-0.475,0.461-0.944,0.694-1.415c0.238-0.48,0.473-0.961,0.719-1.436
			c0.243-0.468,0.496-0.93,0.747-1.393c0.254-0.469,0.505-0.938,0.767-1.402c0.26-0.46,0.53-0.913,0.797-1.368
			c0.27-0.458,0.538-0.917,0.817-1.371c0.277-0.451,0.563-0.895,0.848-1.341c0.286-0.447,0.57-0.894,0.864-1.336
			s0.596-0.878,0.898-1.314c0.301-0.435,0.601-0.87,0.909-1.3c0.31-0.432,0.629-0.858,0.948-1.285
			c0.316-0.423,0.631-0.846,0.954-1.263c0.326-0.421,0.66-0.836,0.994-1.252c0.331-0.412,0.663-0.823,1.001-1.229
			c0.341-0.408,0.689-0.811,1.037-1.213c0.347-0.401,0.695-0.802,1.05-1.198c0.355-0.396,0.718-0.786,1.08-1.176
			c0.362-0.389,0.724-0.776,1.093-1.158c0.37-0.384,0.747-0.762,1.125-1.139c0.377-0.377,0.756-0.752,1.14-1.123
			c0.383-0.369,0.772-0.733,1.163-1.096c0.392-0.364,0.786-0.727,1.185-1.085c0.398-0.356,0.8-0.707,1.205-1.056
			c0.406-0.351,0.815-0.7,1.228-1.044c0.411-0.342,0.826-0.679,1.244-1.014c0.421-0.338,0.845-0.673,1.273-1.004
			c0.423-0.326,0.85-0.648,1.279-0.968c0.436-0.325,0.875-0.646,1.319-0.963c0.434-0.311,0.872-0.617,1.313-0.921
			c0.452-0.311,0.906-0.618,1.364-0.921c0.445-0.294,0.894-0.585,1.345-0.872c0.467-0.297,0.937-0.59,1.41-0.878
			c0.456-0.278,0.915-0.553,1.377-0.823c0.48-0.281,0.964-0.558,1.451-0.831c0.467-0.262,0.937-0.521,1.41-0.775
			c0.495-0.266,0.994-0.527,1.496-0.785c0.476-0.245,0.954-0.486,1.436-0.723c0.379-0.186,0.762-0.366,1.145-0.547
			c11.239,5.908,24.018,9.27,37.572,9.27c13.555,0,26.333-3.362,37.572-9.27c0.38,0.18,0.76,0.359,1.136,0.543
			c0.488,0.24,0.971,0.484,1.453,0.731c0.496,0.255,0.99,0.513,1.48,0.776c0.478,0.257,0.953,0.519,1.425,0.784
			c0.481,0.27,0.959,0.543,1.433,0.821c0.469,0.274,0.934,0.553,1.396,0.835c0.467,0.285,0.93,0.573,1.39,0.866
			c0.458,0.291,0.912,0.585,1.363,0.884c0.453,0.299,0.902,0.603,1.348,0.91c0.445,0.307,0.888,0.616,1.327,0.93
			c0.439,0.314,0.873,0.632,1.305,0.954c0.434,0.322,0.865,0.647,1.292,0.977c0.424,0.328,0.844,0.66,1.262,0.995
			c0.42,0.337,0.838,0.676,1.252,1.02c0.411,0.342,0.817,0.689,1.221,1.038c0.407,0.351,0.812,0.704,1.212,1.063
			c0.396,0.355,0.787,0.715,1.176,1.076c0.394,0.366,0.787,0.734,1.174,1.107c0.381,0.367,0.756,0.739,1.129,1.112
			c0.38,0.38,0.76,0.761,1.133,1.147c0.366,0.38,0.727,0.764,1.086,1.15c0.366,0.393,0.731,0.787,1.089,1.186
			c0.352,0.392,0.697,0.789,1.041,1.187c0.351,0.405,0.702,0.811,1.045,1.223c0.337,0.403,0.666,0.812,0.995,1.221
			c0.336,0.418,0.672,0.835,1,1.259c0.322,0.415,0.635,0.836,0.949,1.257c0.32,0.428,0.64,0.857,0.952,1.291
			c0.307,0.427,0.606,0.861,0.905,1.294c0.303,0.438,0.607,0.876,0.902,1.32c0.292,0.439,0.574,0.883,0.858,1.327
			c0.287,0.449,0.575,0.897,0.854,1.351c0.276,0.449,0.542,0.905,0.81,1.359c0.27,0.458,0.542,0.915,0.803,1.378
			c0.261,0.462,0.511,0.93,0.764,1.396c0.252,0.465,0.506,0.929,0.749,1.398c0.246,0.474,0.48,0.955,0.718,1.434
			c0.233,0.471,0.47,0.941,0.695,1.417c0.23,0.486,0.448,0.977,0.668,1.467c0.216,0.479,0.435,0.955,0.642,1.438
			c0.213,0.495,0.412,0.996,0.616,1.496c0.198,0.486,0.4,0.97,0.589,1.46c0.196,0.507,0.379,1.02,0.566,1.532
			c0.179,0.489,0.362,0.976,0.532,1.469c0.18,0.521,0.346,1.048,0.516,1.573c0.159,0.491,0.324,0.98,0.474,1.475
			c0.163,0.533,0.31,1.072,0.463,1.609c0.14,0.493,0.286,0.984,0.418,1.481c0.145,0.547,0.274,1.099,0.409,1.65
			c0.121,0.493,0.248,0.985,0.36,1.481c0.127,0.562,0.237,1.129,0.354,1.694c0.101,0.491,0.209,0.98,0.302,1.474
			c0.109,0.578,0.199,1.161,0.297,1.743c0.081,0.487,0.171,0.971,0.244,1.461c0.09,0.603,0.162,1.211,0.24,1.817
			c0.061,0.473,0.131,0.943,0.184,1.418c0.072,0.642,0.124,1.289,0.182,1.935c0.04,0.444,0.09,0.885,0.123,1.33
			c0.055,0.733,0.088,1.471,0.124,2.208c0.018,0.361,0.047,0.721,0.06,1.083c0.041,1.103,0.062,2.209,0.062,3.319v11.319v13.757
			H98.121z M294.015,288.12c-0.196-2.436-0.478-4.857-0.836-7.263c-0.057-0.381-0.125-0.759-0.186-1.139
			c-0.139-0.871-0.284-1.74-0.445-2.606c-0.085-0.456-0.178-0.91-0.269-1.365c-0.157-0.791-0.321-1.58-0.496-2.366
			c-0.106-0.474-0.216-0.948-0.328-1.42c-0.183-0.772-0.375-1.541-0.575-2.308c-0.121-0.465-0.242-0.929-0.37-1.393
			c-0.219-0.798-0.453-1.592-0.691-2.385c-0.126-0.418-0.246-0.837-0.377-1.254c-0.295-0.939-0.607-1.873-0.928-2.805
			c-0.09-0.26-0.172-0.523-0.264-0.783c-0.422-1.195-0.865-2.383-1.33-3.564c-0.1-0.253-0.209-0.503-0.311-0.756
			c-0.369-0.917-0.747-1.832-1.142-2.74c-0.175-0.403-0.36-0.801-0.54-1.202c-0.34-0.756-0.684-1.509-1.042-2.257
			c-0.209-0.438-0.425-0.873-0.64-1.308c-0.351-0.71-0.71-1.417-1.077-2.12c-0.23-0.44-0.461-0.878-0.697-1.315
			c-0.38-0.703-0.77-1.401-1.166-2.097c-0.238-0.418-0.473-0.836-0.716-1.251c-0.44-0.751-0.895-1.494-1.355-2.236
			c-0.214-0.346-0.422-0.695-0.64-1.038c-0.685-1.079-1.387-2.15-2.113-3.209c-0.676-0.986-1.371-1.954-2.075-2.914
			c-0.204-0.278-0.412-0.553-0.618-0.829c-0.541-0.723-1.09-1.437-1.647-2.145c-0.201-0.255-0.4-0.513-0.604-0.766
			c-0.739-0.922-1.49-1.834-2.257-2.729c-0.1-0.116-0.203-0.229-0.303-0.345c-0.676-0.783-1.364-1.555-2.061-2.317
			c-0.24-0.262-0.481-0.521-0.723-0.781c-0.618-0.663-1.245-1.318-1.879-1.964c-0.209-0.213-0.414-0.428-0.625-0.639
			c-0.825-0.828-1.663-1.644-2.513-2.444c-0.175-0.165-0.355-0.325-0.531-0.489c-0.695-0.645-1.397-1.28-2.107-1.906
			c-0.27-0.238-0.542-0.474-0.814-0.71c-0.708-0.611-1.423-1.212-2.146-1.804c-0.197-0.161-0.39-0.326-0.588-0.486
			c-0.906-0.732-1.825-1.448-2.754-2.15c-0.232-0.175-0.468-0.345-0.701-0.518c-0.728-0.54-1.461-1.072-2.203-1.594
			c-0.291-0.205-0.582-0.409-0.874-0.611c-0.828-0.571-1.663-1.131-2.507-1.679c-0.148-0.096-0.293-0.196-0.441-0.291
			c-0.852-0.547-1.71-1.084-2.578-1.608c0.224-0.213,0.434-0.44,0.655-0.656c0.62-0.6,1.229-1.21,1.829-1.83
			c0.335-0.346,0.668-0.693,0.996-1.045c0.655-0.7,1.293-1.414,1.923-2.137c0.268-0.307,0.537-0.612,0.8-0.924
			c0.671-0.794,1.323-1.605,1.964-2.426c0.21-0.268,0.425-0.532,0.631-0.803c0.643-0.845,1.264-1.707,1.875-2.577
			c3.902,0.573,7.834,0.863,11.754,0.863c13.555,0,26.333-3.362,37.572-9.271c30.855,14.618,50.548,45.373,50.548,79.631v25.074
			H294.015z"
          />
        </g>
      </g>
    </svg>
  );
};
const AdanianIcon = ({ color, size }) => (
  <svg
    fill={color}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="sidebar-svg-icons  pe-1"
    height={size}
    strokeWidth="0.1"

  >
    <path strokeWidth="0" d="M2,21h8a1,1,0,0,0,0-2H3.071A7.011,7.011,0,0,1,10,13a5.044,5.044,0,1,0-3.377-1.337A9.01,9.01,0,0,0,1,20,1,1,0,0,0,2,21ZM10,5A3,3,0,1,1,7,8,3,3,0,0,1,10,5ZM20,15l3,.438L20.5,17.5l.781,3.5L18.5,19l-2.781,2,.781-3.5L14,15.438,17,15l1.5-3Z" />
  </svg>
);

const VideoIdIcon = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 48 48"
      className="sidebar-svg-icons"
      fill={color}
      height="4dvh"
    >
      <g>
        <g>
          <path
            d="M47.987,21.938c-0.006-0.091-0.023-0.178-0.053-0.264c-0.011-0.032-0.019-0.063-0.033-0.094
			c-0.048-0.104-0.109-0.202-0.193-0.285c-0.001-0.001-0.001-0.001-0.001-0.001L42,15.586V10c0-0.022-0.011-0.041-0.013-0.063
			c-0.006-0.088-0.023-0.173-0.051-0.257c-0.011-0.032-0.019-0.063-0.034-0.094c-0.049-0.106-0.11-0.207-0.196-0.293l-9-9
			c-0.086-0.086-0.187-0.147-0.294-0.196c-0.03-0.014-0.06-0.022-0.091-0.033c-0.085-0.029-0.172-0.047-0.262-0.052
			C32.039,0.01,32.021,0,32,0H7C6.448,0,6,0.448,6,1v14.586l-5.707,5.707c0,0-0.001,0.001-0.002,0.002
			c-0.084,0.084-0.144,0.182-0.192,0.285c-0.014,0.031-0.022,0.062-0.033,0.094c-0.03,0.086-0.048,0.173-0.053,0.264
			C0.011,21.96,0,21.978,0,22v19c0,0.552,0.448,1,1,1h5v5c0,0.552,0.448,1,1,1h34c0.552,0,1-0.448,1-1v-5h5c0.552,0,1-0.448,1-1V22
			C48,21.978,47.989,21.96,47.987,21.938z M44.586,21H42v-2.586L44.586,21z M38.586,9H33V3.414L38.586,9z M8,2h23v8
			c0,0.552,0.448,1,1,1h8v5v5H8v-5V2z M6,18.414V21H3.414L6,18.414z M40,46H8v-4h32V46z M46,40H2V23h5h34h5V40z"
          />
          <rect x="18.143" y="25.964" width="2.04" height="12.036" />
          <path
            d="M25.657,25.964h-3.026V38h3.009c1.553,0,2.729-0.524,3.528-1.572c0.799-1.049,1.198-2.525,1.198-4.429
			c0-1.904-0.399-3.386-1.198-4.446C28.369,26.494,27.199,25.964,25.657,25.964z M28.131,33.843
			c-0.13,0.528-0.315,0.967-0.553,1.318c-0.238,0.351-0.521,0.615-0.85,0.79c-0.329,0.176-0.686,0.264-1.071,0.264h-0.969v-8.466
			h0.969c0.385,0,0.742,0.088,1.071,0.264c0.329,0.175,0.612,0.439,0.85,0.79c0.238,0.351,0.422,0.793,0.553,1.326
			c0.13,0.533,0.195,1.156,0.195,1.87C28.326,32.702,28.261,33.316,28.131,33.843z"
          />
        </g>
      </g>
    </svg>
  );
};

const VideoIcon = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 576 512"
      className="sidebar-svg-icons"
      fill={color}
      height="1em"
    >
      <path d="M543.9 96c-6.2 0-12.5 1.8-18.2 5.7L416 170.1v-58.3c0-26.4-23.2-47.8-51.8-47.8H51.8C23.2 64 0 85.4 0 111.8v288.4C0 426.6 23.2 448 51.8 448h312.4c28.6 0 51.8-21.4 51.8-47.8v-58.3l109.7 68.3c5.7 4 12.1 5.7 18.2 5.7 16.6 0 32.1-13 32.1-31.5V127.5C576 109 560.5 96 543.9 96zM368 200v198.9c-.6.4-1.8 1.1-3.8 1.1H51.8c-2 0-3.2-.6-3.8-1.1V113.1c.6-.4 1.8-1.1 3.8-1.1h312.4c2 0 3.2.6 3.8 1.1V200zm160 155.2l-112-69.8v-58.7l112-69.8v198.3z"></path>
    </svg>
  );
};

const SendNotification = ({ color, size }) => {
  return (
    <svg
      data-icon="true"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 24 24"
      fill="none"
      className="sidebar-svg-icons"
      height="1em"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M20 4L3 11L10 14M20 4L13 21L10 14M20 4L10 14"
          stroke="#ffffff"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};



export {
  DashboardIcon,
  ArticleIcon,
  PlayIcon,
  VideoIcon,
  VideoSection,
  StaticInfoIcon,
  MsLogo,
  SendNotification,
  StartTimeIcon,
  EndTimeIcon,
  VideoIdIcon,
  IdIcon,
  ParticipantIcon,
  AdanianIcon,
};
